import React from 'react'
import { result } from 'libraries/lodash'
import Error from 'components/shared/Error'
import { updatePageState } from 'front-end-core/services/PageStateService'
import { refreshPrecedents } from 'services/PrecedentsService'
import HeadingContainer from 'redux/containers/pages/precedentscontent/HeadingContainer'

const Sections = (props) => {
  const childSections =
    result(props.response, 'childSections', [])
      .map(id => props.response.nodes[id])
      .filter(section => section.active)

  return childSections.length === 0
    ? <Error title='No content' />
    : (
      <ul className='list-reset ml0 mv0 pa0'>
        {childSections.map(section => <ChildSection key={section.id} {...section} {...props} />)}
      </ul>
      )
}

const ChildSection = ({
  id: childId,
  title,
  sectionId,
  view,
  response,
  userPermissions,
  expandedSection,
  isAdmin,
  sectionTitle
}) => (
  <HeadingContainer
    id={childId}
    {...{ title, sectionId, view, userPermissions, sectionTitle }}
    nodes={result(response, 'nodes')}
    files={response.files}
    parents={response.parents}
    expanded={expandedSection === childId}
    toggleExpandedSection={(id) => updatePageState({ expandedSection: expandedSection !== id ? id : null })}
    refreshPrecedents={(aol) => refreshPrecedents(aol)}
    selectedIds={response.selectedIds}
    dragChildren={isAdmin}
  />
)

export default Sections
